import React from 'react'

import { useRecoilValue, useRecoilCallback } from 'recoil'

import {
  messageState,
  attachmentsState
} from 'Pages/OverviewMessage/recoil/state/message'
import {
  downloadAttachmentCallback,
  removeAttachmentCallback
} from 'Pages/OverviewMessage/recoil/callbacks/callbacks'

import AttachmentItem from './AttachmentItem'

const Attachments = () => {
  const { id } = useRecoilValue(messageState)
  const { attachments } = useRecoilValue(attachmentsState)

  const downloadAttachment = useRecoilCallback(downloadAttachmentCallback, [])
  const removeAttachment = useRecoilCallback(removeAttachmentCallback, [])

  return (
    <>
      {attachments.map((attachment, index) => (
        <AttachmentItem
          key={attachment.name}
          idMessage={id}
          {...attachment}
          onDownloadAttachment={downloadAttachment}
          onRemoveAttachment={removeAttachment}
          isLast={attachments.length === index + 1}
        />
      ))}
    </>
  )
}

export default Attachments
